/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Topic_DrivingInputs */

const en_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving`)
};

const es_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving`)
};

const de_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschläge`)
};

const zh_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开球`)
};

const ar_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الضربة البعيدة`)
};

const fr_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive`)
};

const vi_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving`)
};

const sw_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupiga driver`)
};

const th_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไดรฟ์`)
};

const bs_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving`)
};

const ja_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライバーショット`)
};

const ko_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드라이버`)
};

const pt_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive`)
};

const it_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive`)
};

const sv_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utslag`)
};

const nl_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afslag`)
};

const da_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udslag`)
};

const nb_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utslag`)
};

const fi_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draivit`)
};

const pl_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uderzenia driverem`)
};

const ru_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Драйв`)
};

const tr_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver vuruşları`)
};

const hi_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्राइव शॉट`)
};

const id_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pukulan driver`)
};

const ms_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pukulan driver`)
};

const cs_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpaly driverem`)
};

const el_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ντράιβ`)
};

const he_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חבטות דרייבר`)
};

const af_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dryfhoue`)
};

const hu_practice_topic_driving = /** @type {(inputs: Practice_Topic_DrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive-ütések`)
};

/**
* | output |
* | --- |
* | "Driving" |
*
* @param {Practice_Topic_DrivingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_topic_driving = /** @type {((inputs?: Practice_Topic_DrivingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Topic_DrivingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_topic_driving(inputs)
	if (locale === "de") return de_practice_topic_driving(inputs)
	if (locale === "zh") return zh_practice_topic_driving(inputs)
	if (locale === "ar") return ar_practice_topic_driving(inputs)
	if (locale === "fr") return fr_practice_topic_driving(inputs)
	if (locale === "vi") return vi_practice_topic_driving(inputs)
	if (locale === "sw") return sw_practice_topic_driving(inputs)
	if (locale === "th") return th_practice_topic_driving(inputs)
	if (locale === "bs") return bs_practice_topic_driving(inputs)
	if (locale === "ja") return ja_practice_topic_driving(inputs)
	if (locale === "ko") return ko_practice_topic_driving(inputs)
	if (locale === "pt") return pt_practice_topic_driving(inputs)
	if (locale === "it") return it_practice_topic_driving(inputs)
	if (locale === "sv") return sv_practice_topic_driving(inputs)
	if (locale === "nl") return nl_practice_topic_driving(inputs)
	if (locale === "da") return da_practice_topic_driving(inputs)
	if (locale === "nb") return nb_practice_topic_driving(inputs)
	if (locale === "fi") return fi_practice_topic_driving(inputs)
	if (locale === "pl") return pl_practice_topic_driving(inputs)
	if (locale === "ru") return ru_practice_topic_driving(inputs)
	if (locale === "tr") return tr_practice_topic_driving(inputs)
	if (locale === "hi") return hi_practice_topic_driving(inputs)
	if (locale === "id") return id_practice_topic_driving(inputs)
	if (locale === "ms") return ms_practice_topic_driving(inputs)
	if (locale === "cs") return cs_practice_topic_driving(inputs)
	if (locale === "el") return el_practice_topic_driving(inputs)
	if (locale === "he") return he_practice_topic_driving(inputs)
	if (locale === "af") return af_practice_topic_driving(inputs)
	if (locale === "hu") return hu_practice_topic_driving(inputs)
	return en_practice_topic_driving(inputs)
});